import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["data-bs-target"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content umt-form" }
const _hoisted_5 = {
  class: "modal-header p-4",
  id: "kt_modal_add_customer_header"
}
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "svg-icon svg-icon-2x text-primary me-3" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div><h2 class=\"fw-bolder mb-1\">Quét hồ sơ bằng Azure AI</h2><div class=\"text-muted fs-7\"><span class=\"fw-semibold text-gray-800\">① Chọn hồ sơ hoặc tải ảnh từ máy</span> → <span class=\"fw-semibold text-gray-800\">② chọn ảnh &amp; đặt loại</span> → <span class=\"fw-semibold text-gray-800\">③ bấm Phân tích</span> để tự trích xuất thông tin.</div></div>", 1)
const _hoisted_9 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_10 = { class: "svg-icon svg-icon-1" }
const _hoisted_11 = { class: "modal-body pt-2" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12 mb-3" }
const _hoisted_15 = { class: "fv-row flex-md-root" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nguồn ảnh giấy tờ", -1)
const _hoisted_17 = { class: "d-flex gap-4 flex-stack flex-wrap" }
const _hoisted_18 = { class: "d-flex gap-3 align-items-center flex-wrap" }
const _hoisted_19 = { style: {"min-width":"260px"} }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8" }, "hoặc", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-upload me-1" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-upc-scan me-1" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"text-muted fs-8 mt-2\"><i class=\"bi bi-info-circle me-1\"></i>Có thể <span class=\"fw-semibold text-gray-800\">chọn hồ sơ có sẵn</span> hoặc <span class=\"fw-semibold text-gray-800\">tải ảnh từ máy</span> (dùng cho ứng viên chưa có hồ sơ). Hiện chỉ phân tích được <span class=\"fw-semibold text-gray-800\">CCCD mặt trước</span> và <span class=\"fw-semibold text-gray-800\">Học bạ lớp 12</span> — đặt đúng loại thì nút Phân tích mới bật. </div>", 1)
const _hoisted_24 = { class: "col-2 mh-500px overflow-auto" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold text-gray-700 mb-2" }, "Ảnh giấy tờ", -1)
const _hoisted_26 = {
  key: 0,
  class: "text-muted fs-8 text-center py-5"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["src", "alt", "title"]
const _hoisted_29 = { class: "col-5 bg-gray-200 h-500px p-3 bg-img rounded d-flex align-items-center justify-content-center" }
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 1,
  class: "text-muted fs-7 text-center px-3"
}
const _hoisted_32 = { class: "col-5 bg-gray-200 h-500px p-3 rounded overflow-auto" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold text-gray-700 mb-3" }, "Thông tin trích xuất từ ảnh", -1)
const _hoisted_34 = {
  key: 0,
  class: ""
}
const _hoisted_35 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_36 = { class: "" }
const _hoisted_37 = { class: "required form-label" }
const _hoisted_38 = { class: "text-end" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_41 = { class: "mb-3 fv-row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Họ tên", -1)
const _hoisted_43 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_44 = { class: "mb-3 fv-row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Ngày, tháng, năm sinh", -1)
const _hoisted_46 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_47 = { class: "mb-3 fv-row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  class: "required form-label",
  id: "tick-scroll"
}, "CMND/CCCD", -1)
const _hoisted_49 = { class: "text-end" }
const _hoisted_50 = {
  type: "button",
  class: "btn btn-sm btn-light-primary hide",
  "data-bs-toggle": "modal",
  ref: "kt_modal_add_admissions_application",
  "data-bs-target": "#kt_modal_add_admissions_application"
}
const _hoisted_51 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_52 = { class: "modal-content umt-form" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header",
  id: "kt_modal_add_customer_header"
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Kiểm tra và lưu hồ sơ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_AddCustomerModal = _resolveComponent("AddCustomerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-success me-3 d-none",
      ref: "call_modal_run_analysis",
      "data-bs-toggle": "modal",
      "data-bs-target": `#${_ctx.id}`
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      class: "modal fade",
      id: _ctx.id,
      ref: "addRunAnalysis",
      tabindex: "-1",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen004.svg" })
              ]),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              placeholder: "Chọn hồ sơ có sẵn",
                              filterable: true,
                              onChange: _cache[0] || (_cache[0] = e=>{
                          _ctx.getAdFiles(_ctx.admissionwinnerid)
                        }),
                              modelValue: _ctx.admissionwinnerid,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.admissionwinnerid) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajor, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _hoisted_20,
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-light-primary",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.triggerLocalPicker && _ctx.triggerLocalPicker(...args)))
                          }, [
                            _hoisted_21,
                            _createTextVNode(" Tải ảnh từ máy ")
                          ]),
                          _createElementVNode("input", {
                            ref: "localFileInput",
                            type: "file",
                            accept: "image/*",
                            multiple: "",
                            class: "d-none",
                            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPickLocalFiles && _ctx.onPickLocalFiles(...args)))
                          }, null, 544)
                        ]),
                        _createElementVNode("button", {
                          class: _normalizeClass(["btn btn-success", !_ctx.imgActive || !['hocba12','cccdtruoc'].includes(_ctx.tagAction)?'disabled':'']),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.runAnalysis()))
                        }, [
                          _hoisted_22,
                          _createTextVNode(" Phân tích ảnh ")
                        ], 2)
                      ]),
                      _hoisted_23
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    (!_ctx.dataFiles || !_ctx.dataFiles.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.admissionwinnerid ? 'Hồ sơ này chưa có ảnh giấy tờ.' : 'Chọn hồ sơ để xem ảnh giấy tờ.'), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataFiles, (customer, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "position-relative p-2 text-center",
                        key: index
                      }, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_Multiselect, {
                            class: "muti-select-custom custom-w",
                            options: [ 
                        { value: 'cccdtruoc', label: 'CCCD mặt trước' }, 
                        { value: 'cccdsau', label: 'CCCD mặt sau' }, 
                        { value: 'hocba10', label: 'Học bạ lớp 10' },
                        { value: 'hocba11', label: 'Học bạ lớp 11' },
                        { value: 'hocba12', label: 'Học bạ lớp 12' },
                        { value: 'khac', label: 'Giấy tờ khác' },
                        ],
                            placeholder: "Chọn",
                            searchable: true,
                            modelValue: customer.label,
                            "onUpdate:modelValue": ($event: any) => ((customer.label) = $event),
                            "clear-on-select": true,
                            onSelect: e=>_ctx.onSelectTag({...customer, select: e})
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onSelect"])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["position-relative bg-img", {'border border-2 border-primary border-solid': customer.filePath == _ctx.imgActive}]),
                          onClick: (e)=>{
                    _ctx.imgActive = customer.filePath
                    _ctx.tagAction = customer.label
                    _ctx.imgActiveFile = customer.file || null
                  }
                        }, [
                          _createElementVNode("img", {
                            class: "w-50px m-auto img-view",
                            src: customer.filePath,
                            alt: customer.fileName,
                            title: customer.fileName
                          }, null, 8, _hoisted_28)
                        ], 10, _hoisted_27)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    (_ctx.imgActive)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.imgActive,
                          class: "w-100 h-100 img-view",
                          alt: ""
                        }, null, 8, _hoisted_30))
                      : (_openBlock(), _createElementBlock("div", _hoisted_31, "Chọn một ảnh giấy tờ ở cột trái để xem trước."))
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    (_ctx.dataPoints.class12AverageMathScore)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrSubject, (value, name, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "w-20 mb-4",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("label", _hoisted_37, _toDisplayString(name), 1),
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    onKeypress: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isNumber($event))),
                                    class: "text-transform-uppercase",
                                    name: value,
                                    modelValue: _ctx.dataPoints[value],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.dataPoints[value]) = $event),
                                    placeholder: "Điểm"
                                  }, null, 8, ["name", "modelValue", "onUpdate:modelValue"])
                                ])
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("button", {
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submitPointsData && _ctx.submitPointsData(...args))),
                              class: "btn btn-primary me-auto"
                            }, "Áp dụng")
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.formData.idCard)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _hoisted_42,
                              _createVNode(_component_el_input, {
                                type: "text",
                                class: "mb-2 text-transform-uppercase",
                                name: "fullname",
                                modelValue: _ctx.formData.fullName,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.fullName) = $event)),
                                placeholder: "Họ tên đầy đủ"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _hoisted_45,
                              _createVNode(_component_el_date_picker, {
                                class: "w-100",
                                modelValue: _ctx.formData.dateOfBirth,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.dateOfBirth) = $event)),
                                name: "birthday",
                                placeholder: "Ngày/tháng/năm",
                                format: "DD/MM/YYYY",
                                "default-value": new Date('01/01/2005')
                              }, null, 8, ["modelValue", "default-value"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _hoisted_48,
                              _createVNode(_component_el_input, {
                                type: "text",
                                class: "",
                                name: "idCard",
                                modelValue: _ctx.formData.idCard,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.idCard) = $event)),
                                placeholder: "CMND/CCCD"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("button", {
                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.submitData && _ctx.submitData(...args))),
                              class: "btn btn-primary me-auto"
                            }, "Áp dụng")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("button", _hoisted_50, null, 512),
      _createElementVNode("div", {
        class: _normalizeClass(["modal", {'d-block show': _ctx.isCheckMajor,'fade': !_ctx.isCheckMajor}]),
        id: "kt_modal_add_admissions_application",
        ref: "addCustomerModalRef",
        tabindex: "-1",
        "aria-hidden": "true"
      }, [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createVNode(_component_AddCustomerModal, {
              ref: "callAddCustomerModal",
              onUpdateData: _ctx.updateData,
              onCloseModal: _ctx.closeModal,
              "is-edit": true,
              "is-appraised": _ctx.isAppraised,
              priorityScore: _ctx.priorityScore,
              "data-adm": _ctx.dataAdmissionRegister,
              "order-number": undefined,
              isInModalAi: true
            }, null, 8, ["onUpdateData", "onCloseModal", "is-appraised", "priorityScore", "data-adm"])
          ])
        ])
      ], 2)
    ], 8, _hoisted_2)
  ], 64))
}